import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ITConsulting = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="IT Consulting" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>IT Consulting</h2>
                        <h3>Get Your Business Aligned</h3>
                        <p>We help you digitalize operations, optimize portfolios, and implement the latest technologies. Our team of strategists, enterprise architects, and transformation experts would harness technology to reinvent business of any kind.</p>
                        <h3>IT Strategy Consulting</h3>
                        <ul>
                            <li>Outline strategies that address business needs & IT resources</li>
                            <li>Align IT strategy with business strategy</li>
                            <li>Enhance architectural design</li>
                            <li>Strategic initiatives for development, modernization, & migration</li>
                        </ul>
                        <h3>IT Assessment</h3>
                        <p>Gain a deeper understanding of your envirnoment. To enhance efficiency, security, and compliance of IT infrastructure</p>
                        <div className="row mt-5">
                            <div className="col-md-6">
                                <p>We assess</p>
                                <ul>
                                    <li>Oppurtunities for cost optimization</li>
                                    <li>Network security</li>
                                    <li>Business applications</li>
                                    <li>Server infrastructure</li>
                                    <li>Data Storage</li>
                                    <li>Cloud services</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>IT Operations Consulting</h3>
                                <ul>
                                    <li>Connect boardroom strategies to the frontline</li>
                                    <li>Address how processes can be refined</li>
                                    <li>Identify glitches in workflows</li>
                                    <li>Assist enterprise to automate process and operation</li>
                                    <li>Uplift sales operation by restructuring client engagement models</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>Technology Consulting</h3>
                                <ul>
                                    <li>Planning roadmap for technology adoption</li>
                                    <li>Assist choosing right technology in line with your industry</li>
                                    <li>Risk assessment analysis</li>
                                    <li>Integrate cutting edge technology tools</li>
                                    <li>Security consulting</li>
                                    <li>Recovery plan</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>Application Support</h3>
                                <ul>
                                    <li>Pro Active Monitoring</li>
                                    <li>Security Testing</li>
                                    <li>Performance Modelling</li>
                                    <li>Configuration Management</li>
                                    <li>Bug Analysis</li>
                                    <li>Plan application modernization activities</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ITConsulting;